export default {
    menu: {
        home: 'Home',
        about_us: 'About Us',
        our_services: 'Our Services',
        products: 'Products',
        news: 'News',
        investor_relations: 'Investor Relations',
        contact_us: 'Contact Us',
    },
    content: {
        home: {
            title: 'Premium Pet Food Manufacturer',
            subtitle: 'Quality nutrition for your beloved pets',
            hero: {
                title: 'Welcome to PETPAL Products',
                subtitle: 'Premium Pet Food Manufacturer',
            },
            banners: {
                title: 'Our Hero Banners',
                learn_more: 'Learn More',
            },
            products: {
                title: 'Featured Products',
                subtitle: 'Discover our best-selling and most loved pet food products.',
                view_details: 'View Details',
            },
            news: {
                title: 'Latest News',
                subtitle: 'Stay updated with the latest news and articles from PETPAL.',
                read_more: 'Read More',
            },
            categories: {
                title: 'Product Categories',
                subtitle: 'Explore our wide range of pet food categories.',
            },
            cta: {
                title: 'Ready to work with us?',
                subtitle: 'Get in touch with our team today',
                button: 'Contact Us',
            },
        },
    },
    about: {
        hero: {
            title: 'About PETPAL Products',
            subtitle: 'Leading pet food manufacturer with international quality standards',
        },
        overview: {
            title: 'Company Overview',
            subtitle: 'Learn more about our company',
            description: 'PETPAL Products is a leading manufacturer of premium pet food products with international quality standards.',
            vision: {
                title: 'Our Vision',
                description: 'To be the leading pet food manufacturer in Thailand and Southeast Asia.',
            },
            mission: {
                title: 'Our Mission',
                description: 'To provide high-quality pet food products that meet international standards.',
            },
        },
        values: {
            title: 'Our Values',
            subtitle: 'The principles that guide our work',
            quality: {
                title: 'Quality',
                description: 'We maintain the highest standards in all our products.',
            },
            trust: {
                title: 'Trust',
                description: 'We build lasting relationships with our customers.',
            },
            innovation: {
                title: 'Innovation',
                description: 'We continuously improve our products and processes.',
            },
            sustainability: {
                title: 'Sustainability',
                description: 'We are committed to environmental responsibility.',
            },
        },
        history: {
            title: 'Our History',
            subtitle: 'Our journey to becoming a leading pet food manufacturer',
            founded: {
                title: 'Company Founded',
                description: 'PETPAL Products was established with a vision to provide quality pet food.',
            },
            expansion: {
                title: 'Market Expansion',
                description: 'We expanded our operations to serve customers across Thailand.',
            },
            innovation: {
                title: 'Product Innovation',
                description: 'We launched new product lines with advanced formulations.',
            },
            growth: {
                title: 'Rapid Growth',
                description: 'We achieved significant growth and market recognition.',
            },
        },
        cta: {
            title: 'Ready to work with us?',
            subtitle: 'Get in touch with our team today',
            button: 'Contact Us',
        },
    },
    products: {
        title: 'Our Products',
        subtitle: 'Discover our premium pet food products',
        filters: {
            all_categories: 'All Categories',
            newest: 'Newest',
            name: 'Name',
            updated: 'Updated',
        },
        showing: 'Showing {count} of {total} products',
        no_products: {
            title: 'No Products Found',
            description: 'Try adjusting your filters or check back later for new products.',
        },
    },
    news: {
        title: 'Latest News',
        subtitle: 'Stay updated with our latest news and updates',
        filters: {
            all_categories: 'All Categories',
            latest: 'Latest',
            title: 'Title',
            created: 'Created',
        },
        showing: 'Showing {count} of {total} articles',
        no_news: {
            title: 'No News Found',
            description: 'Try adjusting your filters or check back later for new articles.',
        },
    },
    common: {
        read_more: 'Read More',
        no_image: 'No Image',
        featured: 'Featured',
        view_details: 'View Details',
    },
    custom: {
        contact: {
            title: 'Contact Us',
            subtitle: 'We are ready to serve and answer all your questions',
            description: 'If you have any questions or need more information about our products and services, please contact us through the channels below.',
            head_office: 'Head Office',
            factory: 'Factory',
            phone: 'Phone',
            email: 'Email',
            address: 'Address',
            map: 'Map',
            contact_form: {
                title: 'Send us a Message',
                subtitle: 'Fill out the form below to send us a message',
                name: 'Full Name',
                name_placeholder: 'Please enter your full name',
                email: 'Email',
                email_placeholder: 'Please enter your email',
                phone: 'Phone Number',
                phone_placeholder: 'Please enter your phone number',
                company: 'Company/Organization',
                company_placeholder: 'Please enter your company name (optional)',
                subject: 'Subject',
                subject_placeholder: 'Please enter message subject',
                message: 'Message',
                message_placeholder: 'Please enter your message',
                submit: 'Send Message',
                sending: 'Sending...',
                success: 'Message sent successfully! We will get back to you soon.',
                error: 'Error sending message. Please try again.'
            },
            newsletter: {
                title: 'Subscribe to Our Newsletter',
                subtitle: 'Subscribe to receive news and latest updates from PETPAL',
                email_placeholder: 'Please enter your email to subscribe',
                subscribe: 'Subscribe',
                subscribing: 'Subscribing...',
                success: 'Successfully subscribed to newsletter!',
                error: 'Error subscribing. Please try again.'
            },
            office_hours: 'Office Hours',
            office_hours_value: 'Monday - Saturday: 08:00 - 17:00',
            response_time: 'Response Time',
            response_time_value: 'Within 24 hours',
            get_directions: 'Get Directions',
            call_now: 'Call Now',
            send_email: 'Send Email'
        }
    }
};